// import { cs } from '@/utils'
import cart from '@assets/cart.webp'
import { useUserStore } from '@store/user'
import { Badge } from 'antd'
import { useTranslation } from 'react-i18next'

import { useMallCountStore } from '@/store/mallCount'

import CartStyle from './index.module.scss'
function Cart() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const token = useUserStore((state) => state.token)
  const { cartCountInfo, getCartCountInfo } = useMallCountStore((state) => state)

  useEffect(() => {
    if (token) {
      getCartCountInfo()
    }
  }, [token])

  return (
    token && (
      <div className={CartStyle.cart} onClick={() => navigate('/shoppingcart')}>
        <Badge count={cartCountInfo.cart_count_total || 0} offset={[10, 8]}>
          <div className={CartStyle.box}>
            <img src={cart} alt="" style={{ width: '20px', height: '20px' }} />
            <div>{t('header.cart')}</div>
          </div>
        </Badge>
      </div>
    )
  )
}

export default Cart
